import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LandingModule, LandingPageComponent } from '@app/modules/landing';

export const routes: Routes = [
    {
        path: '',
        component: LandingPageComponent
    },
    {
        path: 'gene-expression',
        component: LandingPageComponent
    },
    {
        path: 'snp',
        component: LandingPageComponent
    },
    {
        path: 'gene-expression/assay/query',
        loadChildren: () => import('./products/ge/assays').then(module => module.TfAssaysRoutingModule)
    },
    {
        path: 'gene-expression/assay',
        loadChildren: () => import('./products/ge/assays').then(module => module.TfAssaysRoutingModule)
    },
    {
        path: 'gene-expression/custom-array/query',
        loadChildren: () => import('./products/ge/custom-array').then(module => module.TfCustomArrayRoutingModule)
    },
    {
        path: 'gene-expression/custom-array',
        loadChildren: () => import('./products/ge/custom-array').then(module => module.TfCustomArrayRoutingModule)
    },
    {
        path: 'gene-expression/array',
        loadChildren: () => import('./products/ge/arrays').then(module => module.TfArraysRoutingModule)
    },
    {
        path: 'gene-expression/array/query',
        loadChildren: () => import('./products/ge/arrays').then(module => module.TfArraysRoutingModule)
    },
    {
        path: 'snp',
        redirectTo: 'snp/assay/query',
        pathMatch: 'full'
    },
    {
        path: 'snp/assay',
        redirectTo: 'snp/assay/query',
        pathMatch: 'full'
    },
    {
        path: 'snp/assay/query',
        loadChildren: () => import('./products/snp').then(module => module.TfSnpRoutingModule)
    },
    {
        path: 'snp/custom-array/query',
        loadChildren: () => import('./products/custom-array-snp').then((module) => module.TfCustomSnpRoutingModule)
    },
    {
        path: 'cnv',
        redirectTo: 'cnv/assay/query',
        pathMatch: 'full'
    },
    {
        path: 'cnv/assay',
        redirectTo: 'cnv/assay/query',
        pathMatch: 'full'
    },
    {
        path: 'cnv/assay/query',
        loadChildren: () => import('./products/cnv').then(module => module.TfCnvModule)
    },
    {
        path: 'microrna/assay/microrna-advanced',
        loadChildren: () => import('./products/microrna/microrna-advanced/microrna-advanced.module').then(module => module.MicrornaAdvancedModule)
    },
    {
        path: 'microrna/custom-array/microrna-advanced',
        loadChildren: () => import('./products/custom-array-advanced-mirna/custom-array-adv-mirna.module').then(module => module.CustomArrayAdvancedMirnaModule)
    },
    {
        path: 'microrna/assay/microrna-classic',
        loadChildren: () => import('./products/microrna/microrna-classic/microrna-classic.module').then(module => module.MicrornaClassicModule)
    },
    {
        path: 'microrna/custom-array/microrna-classic',
        loadChildren: () => import('./products/custom-array-classic-mirna/custom-array-microrna-classic.module').then(module => module.CustomArrayMicrornaClassicModule)
    },
    {
        path: 'microrna/assay/microrna-primary',
        loadChildren: () => import('./products/microrna/microrna-primary/microrna-primary.module').then(module => module.MicrornaPrimaryModule)
    },
    {
        path: 'microrna/array',
        loadChildren: () => import('./products/microrna/microrna-array/microrna-array.module').then(module => module.MicrornaArrayModule)
    },
    {
        path: 'results',
        loadChildren: () => import('./products/unified-card').then(module => module.TfUnifiedCardRoutingModule)
    },
    {
        path: '**',
        component: LandingPageComponent
    },
];

@NgModule({
    imports: [
        LandingModule,
        RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {
}
